import { request } from '@/common/services/request';

const METRIC_EFFECTIVE_PERIOD_PATH = '/api/operations/tenant/metric-effective-period';

export const queryMetricEffectivePeriod = (params) =>
  request(METRIC_EFFECTIVE_PERIOD_PATH, {
    method: 'GET',
    params,
  });

export const saveMetricEffectivePeriod = ({ data }) =>
  request(METRIC_EFFECTIVE_PERIOD_PATH, {
    data: { effectiveStartAt: data.effectiveStartAt },
    method: 'PUT',
    params: { organizationId: data.organizationId },
  });
